import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { HistoryPage } from '@/features/history/pages/history-page'
import { workspaceQueryOptions } from '@/lib/workspace'
export const Route = createFileRoute('/_auth/w/$workspaceSlug/settings/history')({
  component: Screen,
})
function Screen() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <HistoryPage
      slug={workspaceSlug}
      canWrite={workspace.data?.role === 'owner' || workspace.data?.role === 'editor'}
    />
  )
}
